export default {
  dataModel: {
    types: ['pair:Person', 'pair:Organization', 'pair:Place'],
    list: {
      containers: {
        oasis: ['/users', '/organizations', '/places']
      }
    }
  }
};
